<template>
    <div style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="padding-top:20px;padding-bottom:20px;">

            <div style="display:flex;justify-content: space-between;margin-bottom: 10px">
                <div style="font-size:18px;">
                    <p>Replenish Products</p>
                </div>

                <div style="display:flex;justify-content: space-between;">
                    <a-dropdown>
                        <a-menu slot="overlay">
                            <a-menu-item @click="redirectToWaybillPage" key="1">Generate Waybill</a-menu-item>
                            <a-menu-item @click="showPurchaseOrder" key="2">Generate Purchased Orders</a-menu-item>
                        </a-menu>
                        <a-button
                            style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;">
                            Action <a-icon type="down" />
                        </a-button>
                    </a-dropdown>
                    <a-button :loading="exportLoading" @click="exportExcell"
                        style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                        icon="export">
                        Export
                    </a-button>
                </div>
            </div>
            <a-table :columns="columns" :data-source="tableData" :pagination="pagination" :loading="tableLoading"
                class="productTable">
            </a-table>
        </div>
        <a-modal class="modalStyle" :visible="addSupplierVisible" :footer="null" @cancel="handleAddSupplierCancel">

            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Select Supplier</p>
            <div>
                <a-form-model ref="addSupplierForm" :model="newSupplierForm" :rules="rules">
                    <a-row type="flex" justify="center" align="middle">
                        <a-col :span="16">
                            <a-form-model-item label="Select Supplier" ref="supplierId" prop="supplierId">
                                <a-select show-search placeholder="Choose your Supplier" option-filter-prop="children"
                                    v-model="newSupplierForm.supplierId" :filter-option="filterOption">
                                    <a-select-option v-for="supplier in availableSuppliers" :key="supplier.supplierId"
                                        v-bind:value="supplier.supplierId">
                                        {{ supplier.supplierName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                    </a-row>

                    <div style="display:flex;justify-content: center;">
                        <a-spin class="spinner" :spinning="loading" />
                    </div>
                    <div v-show="showAlertMsg" style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-alert message="Product already exist, kindly choose a different product." type="error" />
                    </div>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:10px;">
                        <a-button :loading="modalLoading" @click="saveSupplier"
                            style="background: #418a49;height:40px;color:#fff;width:263px;border-radius:5px;">
                            Save
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>
        <a-modal class="modalStyle" :visible="addDistCenterVisible" :footer="null" @cancel="handleAddDistCenterCancel">

            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Select Distribution
                Center</p>
            <div>
                <a-form-model ref="addDistCenterForm" :model="newDistCenterForm" :rules="rules">
                    <a-row type="flex" justify="center" align="middle">
                        <a-col :span="16">
                            <a-form-model-item label="Select Distribution Center" ref="distributionCenterId"
                                prop="distributionCenterId">
                                <a-select show-search placeholder="Choose your Distribution Center"
                                    option-filter-prop="children" v-model="newDistCenterForm.distributionCenterId"
                                    :filter-option="filterOption">
                                    <a-select-option v-for="distributionCenter in availableDistributionCenters"
                                        :key="distributionCenter.id" v-bind:value="distributionCenter.id">
                                        {{ distributionCenter.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                    </a-row>

                    <div style="display:flex;justify-content: center;">
                        <a-spin class="spinner" :spinning="loading" />
                    </div>
                    <div v-show="showAlertMsg" style="display:flex;justify-content: center;padding-bottom: 10px;">
                        <a-alert message="Product already exist, kindly choose a different product." type="error" />
                    </div>

                    <a-form-model-item
                        style="display: flex;justify-content: center;align-items: center;padding-top:10px;">
                        <a-button :loading="modalLoading" @click="saveDistCenter"
                            style="background: #418a49;height:40px;color:#fff;width:263px;border-radius:5px;">
                            Save
                        </a-button>
                    </a-form-model-item>

                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import XLSX from "xlsx";


const data = [
    {
        id: 1,
        key: 1,
        brandName: "Product 1",
        categoryName: "Vaccine",
        supplierName: "Mutivet",
        revenue: 4433,
        manufacturerName: "Damsto",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 2,
        key: 2,
        brandName: "Product 2",
        categoryName: "Vaccine 2",
        supplierName: "Mutivet 2",
        revenue: 4433,
        manufacturerName: "Damsto 2",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 3,
        key: 3,
        brandName: "Product 3",
        categoryName: "Vaccine 3",
        supplierName: "Mutivet 3",
        revenue: 4433,
        manufacturerName: "Damsto 3",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    }
]

const columns = [

    // {
    // 	title: 'Pre-Order ID',
    // dataIndex: 'id',
    // key:"id"
    // 	// width: 200,
    // },
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name"
        //  width: 150,
    },
    {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        //  width: 150,
    },
    {
        title: 'Supplier',
        dataIndex: 'supplier',
        key: 'supplier',
        //  width: 150,
    },
    {
        title: 'Manufacturer',
        dataIndex: 'manufacturer',
        key: 'manufacturer',
        //  width: 150,
    },
    // {
    //     title: "Max Q'ty",
    //     dataIndex: 'maxQuantity',
    //     // width: 150,
    // },
    // {
    // 	title: 'Ordered Quantity',
    //     dataIndex: 'orderedQuantity',
    //     key:"orderedQuantity"
    //         // width: 150,
    // },
    {
        title: 'Selling Price(Ksh)',
        key: 'sellingPrice',
        dataIndex: 'sellingPrice',
    },
    {
        title: 'Cost Price(Ksh)',
        key: 'costOfPrice',
        dataIndex: 'costOfPrice',
    },
    // {
    // 	title: 'Ordered Value',
    //     dataIndex: 'orderedValue',
    //     key:"quanorderedValuetity"
    //         // width: 150,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity"
        // width: 150,
    },

    {
        title: 'Profit',
        key: 'profit',
        dataIndex: 'profit',
    }
];

// import QuantityEditableCell from './common/QuantityEditableCell';
// import UnitPriceEditableCell from './common/UnitPriceEditableCell';
// import ProductNameEditableCell from './common/ProductNameEditableCell';
// import CategoryEditableCell from './common/CategoryEditableCell';

export default {
    name: "QuickActionReceipt",
    components: {
        // QuantityEditableCell,
        // UnitPriceEditableCell,
        // ProductNameEditableCell,
        // CategoryEditableCell
    },
    data() {
        return {
            columns,
            data,
            addProductVisible: false,
            addDistCenterVisible: false,
            modalLoading: false,
            exportLoading: false,
            tableData: [],
            availableDistributionCenters: [],
            addSupplierVisible: false,
            loading: false,
            tableLoading: false,
            discount: 0,
            deliveryDate: null,
            supplierName: "",
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            shipAddress: "",
            shipCity: "",
            pagination: {
                pageSize: 20
            },
            shipCountry: "",
            shippingMethod: "Land",
            shippinTerm: "",
            showAlertMsg: false,
            newProductForm: {
                productId: "",
            },
            newSupplierForm: {
                supplierId: ''
            },
            newDistCenterForm: {
                distributionCenterId: ''
            },
            supplierPreviewName: '',
            newPreOrderProduct: {},
            availableProducts: [],
            availableSuppliers: [],
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            supplierDetails: {},
            rules: {
                maxQuantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[0-9]*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                supplierId: [
                    { required: true, message: 'Please select supplier', trigger: 'change' },
                ],

                distributionCenterId: [
                    { required: true, message: 'Please select distribution center', trigger: 'change' },
                ],

                quantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],

                price: [
                    { required: true, message: 'Please enter price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo', 'IsAgentProfileAvailable']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.unitQuantity) {
                    return parseFloat(item.unitPrice) * parseFloat(item.unitQuantity)
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount).toFixed(2)
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        }
    },
    methods: {
        ...mapActions(['setPreviewDataInfo', 'getClientProducts', 'getAllSuppliers', 'setPreviewInfo', 'getAllDistributionCenters']),
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        redirectPreviousUrl() {
            this.$router.back()
        },
        handleAddSupplierCancel() {
            this.addSupplierVisible = false
        },
        handleAddDistCenterCancel() {
            this.addDistCenterVisible = false;
        },
        redirectToWaybillPage() {
            this.addDistCenterVisible = true
            // this.$router.push('/waybill-receipt').catch(()=>{});
        },
        showPurchaseOrder() {
            let suppliers = this.tableData.map(supplier => ({
                supplierName: supplier.action.supplierName,
                supplierId: supplier.action.supplierId
            }))

            this.availableSuppliers = _.chain(suppliers)
                .groupBy("supplierId")
                .map((value, key) => ({ supplierId: parseInt(key), supplierName: value[0].supplierName }))
                .value()

            this.addSupplierVisible = true
        },

        saveSupplier() {
            let result = this.availableSuppliers.filter(supplier => supplier.supplierId === this.newSupplierForm.supplierId)

            let supplierProducts = this.tableData.filter(product => product.action.supplierId === this.newSupplierForm.supplierId)

            let originalData = this.tableData.map(product => ({
                key: this.randomString(10),
                id: product.id,
                name: product.action.brandName ? product.action.brandName : "N/A",
                category: product.action.categoryName ? product.action.categoryName : "N/A",
                quantity: '0',
                unitPrice: product.action.purchasePrice ? product.action.purchasePrice.toString() : "0",
                lineTotal: product.action.unitQuantity * product.action.purchasePrice,
                extra_data: product.action

            }))
            let supplierData = supplierProducts.map(product => ({
                key: this.randomString(10),
                id: product.id,
                name: product.action.brandName ? product.action.brandName : "N/A",
                category: product.action.categoryName ? product.action.categoryName : "N/A",
                quantity: '0',
                unitPrice: product.action.purchasePrice ? product.action.purchasePrice.toString() : "0",
                lineTotal: product.action.unitQuantity * product.action.purchasePrice,
                extra_data: product.action

            }))

            // console.log("supplierData | ", supplierData)

            let previewData = {
                discount: '',
                deliveryDate: '',
                supplierName: result[0].supplierName,
                supplierId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: 'Ghana',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: 'Ghana',
                shippingMethod: '',
                shippinTerm: '',
                originalData: originalData,
                tableData: supplierData,
                supplierDetails: {}
            }
            // console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/purchase-receipt').catch(() => { });
        },

        saveDistCenter() {
            let result = this.availableDistributionCenters.filter(distCenter => distCenter.id === this.newDistCenterForm.distributionCenterId)
            let distCenterData = this.tableData.map(product => ({
                key: this.randomString(10),
                id: product.id,
                name: product.action.brandName ? product.action.brandName : "N/A",
                category: product.action.categoryName ? product.action.categoryName : "N/A",
                quantity: '0',
                unitPrice: product.action.purchasePrice ? product.action.purchasePrice.toString() : "0",
                lineTotal: product.action.unitQuantity * product.action.purchasePrice,
                extra_data: product.action

            }))

            let previewData = {
                discount: '',
                deliveryDate: '',
                supplierName: '',
                supplierId: '',
                supplierAddress: '',
                supplierCity: 'Greater Accra',
                supplierCountry: 'Ghana',
                destionation: result[0].name,
                shipAddress: result[0].address,
                shipCity: this.getRegionByDestination(this.newDistCenterForm.distributionCenterId),
                shipCountry: 'Ghana',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distCenterData,
                tableData: distCenterData,
                supplierDetails: {}
            }
            // console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/waybill-receipt').catch(() => { });
        },


        exportExcell() {

            this.exportLoading = true
            const dataToExport = [
                [
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Selling Price",
                    "Cost Price",
                    "Quantity",
                    "Profit"
                ],
            ];

            this.exportLoading = false;

            this.tableData.forEach((v) => {
                dataToExport.push([
                    v.name,
                    v.category,
                    v.supplier,
                    v.manufacturer,
                    v.sellingPrice,
                    v.costOfPrice,
                    v.quantity,
                    v.profit
                ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Replenish-Products-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")
        },

        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },

        getRegionByDestination(id) {
            let region;
            if (id === 1109) {
                region = "Greater Accra"
            } else if (id === 1107) {
                region = "Northern"
            } else if (id === 1106) {
                region = "Bono"
            }
            return region
        },

        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },

    },
    created() {
        if (this.getAllDistributionCenters) {
            this.getAllDistributionCenters().then(response => {
                //    
                if (response.status === 200) {
                    this.availableDistributionCenters = response.data.data;
                } else {
                    console.log('Error | ', response)
                }
            }, error => {
                console.log('Error | ', error)
            })
        }
        // console.log("getPreViewInfo | ", JSON.parse(this.getPreViewInfo))
        if (this.getPreViewInfo) {
            let result = JSON.parse(this.getPreViewInfo)
            // console.log("result | ", result)
            this.tableData = result.originalData.map(product => ({
                id: product.extra_data.id,
                key: product.extra_data.id,
                name: product.extra_data.brandName ? product.extra_data.brandName : "N/A",
                category: product.extra_data.categoryName ? product.extra_data.categoryName : "N/A",
                supplier: product.extra_data.supplierName ? product.extra_data.supplierName : "N/A",
                orderedValue: product.extra_data.revenue ? product.extra_data.revenue : "N/A",
                manufacturer: product.extra_data.manufacturerName ? product.extra_data.manufacturerName : "N/A",
                maxQuantity: product.extra_data.maxQuantity ? product.extra_data.maxQuantity : "N/A",
                orderedQuantity: product.extra_data.quantityOrdered ? product.extra_data.quantityOrdered : "N/A",
                costOfPrice: product.extra_data.purchasePrice ? product.extra_data.purchasePrice : "N/A",
                sellingPrice: product.extra_data.sellingPrice ? product.extra_data.sellingPrice : "N/A",
                quantity: product.quantity ? product.quantity : "N/A",
                profit: product.extra_data.profit ? product.extra_data.profit : "N/A",
                action: product.extra_data
            }))
        }
        // if(this.getClientProducts){
        //     this.params.page = -1
        //     this.params.perPage = -1
        //     this.getClientProducts(this.params).then(response => {
        //     //    
        //     if(response.status === 200){
        //         this.availableProducts = response.data.data;
        //     }else{
        //             console.log('Error | ', response)
        //         }
        //     },error =>{
        //         console.log('Error | ', error)
        //     })
        // }
        // if(this.getSuppliers){
        //     this.getSuppliers()
        // }

    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.productTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.productTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.productTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
</style>